var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3478 4.49818C31.075 -1.42045 39.4865 -1.42045 42.2137 4.49818C43.8813 8.11716 48.0519 9.84471 51.7901 8.46484C57.9036 6.20816 63.8515 12.156 61.5948 18.2695C60.2149 22.0077 61.9425 26.1783 65.5614 27.8459C71.4801 30.5731 71.4801 38.9846 65.5614 41.7118C61.9425 43.3794 60.2149 47.55 61.5948 51.2882C63.8515 57.4017 57.9036 63.3496 51.7901 61.0929C48.0519 59.713 43.8813 61.4406 42.2137 65.0595C39.4865 70.9782 31.075 70.9782 28.3478 65.0595C26.6802 61.4406 22.5096 59.713 18.7714 61.0929C12.6579 63.3496 6.71006 57.4017 8.96674 51.2882C10.3466 47.55 8.61906 43.3794 5.00007 41.7118C-0.918558 38.9846 -0.918558 30.5731 5.00007 27.8459C8.61906 26.1783 10.3466 22.0077 8.96674 18.2695C6.71006 12.156 12.6579 6.20816 18.7714 8.46484C22.5096 9.84471 26.6802 8.11716 28.3478 4.49818Z",
    fill: "#FEBB02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.16f7a518539cf8edf2484322c2ee003a.svg";
export { ForwardRef as ReactComponent };